// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"3fc1c5e5","718":"98280c74"}[chunkId] + ".css";
};